/* NOTICE — coupon strip (snippets/notice-coupon.liquid).
   1. Copies the code on click, with a textarea fallback where the async Clipboard API is
      missing or refused.
   2. Keeps "Get it at" in step with the selected variant. product-info publishes
      variantChange with the section HTML it has just fetched for that variant; the
      price there was worked out in Liquid, so it is copied across rather than recomputed. */
if (!customElements.get('notice-coupon')) {
  customElements.define(
    'notice-coupon',
    class NoticeCoupon extends HTMLElement {
      connectedCallback() {
        this.button = this.querySelector('.nt-coupon__copy');
        this.copyLabel = this.querySelector('[data-coupon-copy-label]');
        this.status = this.querySelector('[data-coupon-status]');
        this.onClick = this.copy.bind(this);
        this.button?.addEventListener('click', this.onClick);

        if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          this.unsubscribe = subscribe(PUB_SUB_EVENTS.variantChange, this.onVariantChange.bind(this));
        }
      }

      disconnectedCallback() {
        this.button?.removeEventListener('click', this.onClick);
        this.unsubscribe?.();
        clearTimeout(this.resetTimer);
      }

      async copy() {
        const code = this.dataset.code;
        if (!code) return;

        let copied = false;
        try {
          await navigator.clipboard.writeText(code);
          copied = true;
        } catch (error) {
          copied = this.copyWithTextarea(code);
        }
        this.showResult(code, copied);
      }

      copyWithTextarea(text) {
        const field = document.createElement('textarea');
        field.value = text;
        field.setAttribute('readonly', '');
        field.style.cssText = 'position:fixed;top:0;left:0;opacity:0;pointer-events:none;';
        document.body.appendChild(field);
        field.select();
        field.setSelectionRange(0, text.length);
        let copied = false;
        try {
          copied = document.execCommand('copy');
        } catch (error) {
          copied = false;
        }
        field.remove();
        this.button?.focus({ preventScroll: true });
        return copied;
      }

      showResult(code, copied) {
        clearTimeout(this.resetTimer);
        this.classList.toggle('is-copied', copied);
        if (this.copyLabel) this.copyLabel.textContent = copied ? 'Copied' : 'Copy';
        if (this.status) {
          this.status.textContent = copied ? `Code ${code} copied` : `Could not copy. The code is ${code}`;
        }
        this.resetTimer = setTimeout(() => {
          this.classList.remove('is-copied');
          if (this.copyLabel) this.copyLabel.textContent = 'Copy';
          if (this.status) this.status.textContent = '';
        }, 2200);
      }

      onVariantChange({ data } = {}) {
        if (!data?.html || data.sectionId !== this.dataset.sectionId) return;
        const next = data.html.querySelector(`notice-coupon[data-slot="${this.dataset.slot}"] [data-coupon-price]`);
        const price = this.querySelector('[data-coupon-price]');
        if (!next || !price) return;
        price.innerHTML = next.innerHTML;
        price.hidden = next.hidden;
      }
    }
  );
}
